// import cookie from "react-cookies";

// const CookieService = (function () {
//   let _service;

//   const ACCESS_TOKEN = "accessToken";
//   const REFRESH_TOKEN = "refreshToken";
//   const REMEMBER_ME = "rememberMe";

//   function _getService() {
//     if (!_service) {
//       _service = this;
//       return _service;
//     }
//     return _service;
//   }

//   function _options(expires) {
//     return {path: "/", expires};
//   }

//   function _setAppToken(tokenObj, rememberMe = false) {
//     cookie.save(ACCESS_TOKEN, tokenObj.access, _options());
//     cookie.save(REMEMBER_ME, rememberMe, _options());
//     if (tokenObj.refresh && rememberMe === true) {
//       const expires = new Date();
//       expires.setDate(Date.now() + 1000 * 60 * 60 * 6);
//       cookie.save(REFRESH_TOKEN, tokenObj.refresh, _options(expires));
//     }
//   }

//   function _getAccessToken() {
//     return cookie.load(ACCESS_TOKEN, _options());
//   }

//   function _getRefreshToken() {
//     if (_getRememberMe() === "true") {
//       return cookie.load(REFRESH_TOKEN, _options());
//     }
//     return null;
//   }

//   function _getRememberMe() {
//     return cookie.load(REMEMBER_ME, _options());
//   }

//   function _clearToken() {
//     cookie.remove(ACCESS_TOKEN, _options());
//     cookie.remove(REFRESH_TOKEN, _options());
//     cookie.remove(REMEMBER_ME, _options());
//   }

//   function _isTokenAvailable() {
//     if (_getRememberMe() === "true") {
//       return _getAccessToken() !== undefined || _getRefreshToken() !== undefined;
//     }

//     return _getAccessToken() !== undefined;
//   }

//   return {
//     getService: _getService,
//     setToken: _setAppToken,
//     getAccessToken: _getAccessToken,
//     getRefreshToken: _getRefreshToken,
//     getRememberMe: _getRememberMe,
//     clearToken: _clearToken,
//     isTokenAvailable: _isTokenAvailable,
//   };
// })();

// export default CookieService;

import cookie from "react-cookies";

export default () => {
  return {
    elements: {
      ACCESS_TOKEN: "accessToken",
      REFRESH_TOKEN: "refreshToken",
      REMEMBER_ME: "rememberMe",
    },

    options(expires) {
      return {path: "/", expires};
    },

    setAppToken(tokenObj, rememberMe = false) {
      cookie.save(this.elements.ACCESS_TOKEN, tokenObj.access, this.options());
      cookie.save(this.elements.REMEMBER_ME, rememberMe, this.options());
      if (rememberMe) {
        const expires = new Date();
        expires.setDate(Date.now() + 1000 * 60 * 60 * 6);
        cookie.save(this.elements.REFRESH_TOKEN, tokenObj.refresh, this.options(expires));
      }
    },

    getAccessToken() {
      return cookie.load(this.elements.ACCESS_TOKEN, this.options());
    },

    getRefreshToken() {
      return cookie.load(this.elements.REFRESH_TOKEN, this.options());
    },

    getRememberMe() {
      return cookie.load(this.elements.REMEMBER_ME, this.options());
    },

    clearToken() {
      cookie.remove(this.elements.ACCESS_TOKEN, this.options());
      cookie.remove(this.elements.REFRESH_TOKEN, this.options());
    },

    isTokenAvailable() {
      return this.getAccessToken() !== undefined || this.getRefreshToken() !== undefined;
    },
  };
};
